import { useContext, useState } from "react";
import Form from "react-bootstrap/Form";
import { Modal } from "react-bootstrap";
import { DataContext } from "../DataContext";
import { Button, PageTemplate, HeaderTemplate, CustomerProduct, CustomerShipping } from "../styles";
import { getCustomerOrder } from "../api/order";
import { ViewReturnsTemplate } from "../templates/ViewReturnsTemplate";
import { convertDate, hasReturnWindowExpired } from "../utils";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { ASSET_URL } from "../constants";

const OrderLookup = () => {
  const navigate = useNavigate();
  const data = useContext(DataContext);

  const [order, setOrder] = useState(null);
  const [showReturnsModal, setShowReturnsModal] = useState(false);
  const [orderSearch, setOrderSearch] = useState("");
  const [orderEmail, setOrderEmail] = useState("");

  const [formSubmitted, setFormSubmitted] = useState(false);

  const getOrder = async () => {
    const order = await getCustomerOrder(orderSearch, orderEmail);
    setOrder(order);
    setFormSubmitted(true);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    let errorMessage;

    if (!orderEmail) {
      errorMessage = "Enter Email Address";
    }

    if (!orderSearch) {
      errorMessage = "Enter Order Number";
    }

    if (orderSearch && orderEmail) {
      try {
        await getOrder();
      } catch (error) {
        console.error(error.message);
        toast.error(error.message);
      }
    } else {
      toast.error(errorMessage);
    }
  };

  const handleViewReturns = () => {
    setShowReturnsModal(true);
  };

  const showCreateReturnButton = (order) => {
    const availableProductsForReturn = () => {
      if (order.returns.length === 0) return true;
      return order.returns[order.returns.length - 1].products.find((product) => {
        return product.returnType === "Keep";
      });
    };
    return (
      !hasReturnWindowExpired(order.updatedAt) &&
      (order.status === "completed" || order.status === "return") &&
      availableProductsForReturn()
    );
  };

  return (
    <>
      <HeaderTemplate className="narrow">
        <div className="header flex-header">
          <div className="title">
            <h1>Order Lookup</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate className="narrow order-lookup">
        <div>
          <form className="order-search" onSubmit={handleSearchSubmit}>
            <Form.Group className="form-group">
              <Form.Control
                type="text"
                onChange={(e) => setOrderSearch(e.target.value)}
                name="orderSearch"
                id="orderSearch"
                placeholder="Order Number"
                value={orderSearch}
              />
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Control
                type="text"
                onChange={(e) => setOrderEmail(e.target.value)}
                name="orderEmail"
                id="orderEmail"
                placeholder="Email"
                value={orderEmail}
              />
            </Form.Group>
            <Button type="submit">Search</Button>
          </form>
          {formSubmitted &&
            (order ? (
              <div className="order-lookup-result">
                <div>
                  <div className="order-history-row" key={order.orderNumber}>
                    <div className="order-history-details">
                      <div>
                        <div className="label">Order</div>
                        <div className="value">{order.orderNumber}</div>
                      </div>
                      <div>
                        <div className="label">Status</div>
                        <div className={`status ${order.status.toLowerCase()}`}>
                          <span>{order.status}</span>
                        </div>
                      </div>
                      <div>
                        <div className="label">Date</div>
                        <div className="value">{convertDate(order.createdAt)}</div>
                      </div>
                    </div>

                    <div className="order-history-buttons">
                      <Button
                        className="order-history-link clear"
                        onClick={() => navigate("/support", { state: { orderNumber: order.orderNumber, previousUrl: "/order-lookup" } })}
                      >
                        Support
                      </Button>
                      {order.tracking && order.status === "shipped" && (
                        <a
                          className="order-history-link clear"
                          href={`https://tools.usps.com/go/TrackConfirmAction?tLabels=${order.tracking}`}
                          target="_blank"
                        >
                          Track Package
                        </a>
                      )}
                      {showCreateReturnButton(order) && (
                        <Button className="order-history-link clear" onClick={() => navigate("/return", { state: { order } })}>
                          Create Return
                        </Button>
                      )}
                      {order.status === "return" && (
                        <Button className="order-history-link clear" onClick={() => handleViewReturns(order)}>
                          View Returns
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
                <CustomerShipping>
                  {order?.shipping && (
                    <div>
                      <div>
                        <strong>Shipping Address</strong>
                      </div>
                      <div>{order.shipping.name}</div>
                      <div>{order.shipping.address.line1}</div>
                      {order.shipping.address.line2 && <div>{order.shipping.address.line2}</div>}
                      <div>
                        {order.shipping.address.city} {order.shipping.address.state} {order.shipping.address.postal_code}{" "}
                      </div>
                    </div>
                  )}
                  {order?.billing && (
                    <div>
                      <div>
                        <strong>Billing Details</strong>
                      </div>
                      <div>{order.billing.name}</div>
                      <div>{order.billing.address.line1}</div>
                      {order.billing.address.line2 && <div>{order.billing.address.line2}</div>}
                      <div>
                        {order.billing.address.city} {order.billing.address.state} {order.billing.address.postal_code}{" "}
                      </div>
                    </div>
                  )}
                </CustomerShipping>
                <div className="table-header products box-padding-2030">
                  <div className="product-image-header">Design</div>
                  {/* <div className="product-name">
            <strong>Description</strong>
          </div> */}
                  {/* <div>
            <strong>Design</strong>
          </div> */}
                  <div className="product-price-header">Price</div>
                  <div className="product-size-header">Size</div>
                  <div className="product-position-header">Position</div>
                  <div className="product-quantity-header">Qty</div>
                </div>
                <div className="table-body products">
                  {order.products.map((product) => {
                    const details = data.getProduct(product.productId);
                    return (
                      <CustomerProduct>
                        <div className="product-image">
                          <picture>
                            <source srcset={`${ASSET_URL}/designs/small/${order.products[0].design}-logo.avif`} type="image/avif" />
                            <img src={`${ASSET_URL}/designs/small/${order.products[0].design}-logo.gif`} className="border" />
                          </picture>
                        </div>
                        <div className="product-price">${details.cost}</div>
                        <div className="product-size">{product.size.toUpperCase()}</div>
                        <div className="product-position">{product.position}</div>
                        <div className="product-quantity">{product.quantity}</div>
                      </CustomerProduct>
                    );
                  })}
                </div>
                <div className="order-footer box-padding-2030">
                  <div>
                    <div>
                      <div>
                        <strong>Payment Method</strong>
                      </div>
                      <div>
                        {order.billing.card.brand} ({order.billing.card.last4})
                      </div>
                    </div>
                  </div>
                  <div className="price-details">
                    <div className="order-footer-labels">
                      <span>Subtotal</span>
                      <span>Shipping</span>
                      <span>Total</span>
                    </div>
                    <div className="order-footer-values">
                      <span>${order.subTotal}</span>
                      <span>${order.shippingRate}</span>
                      <span>${order.total}</span>
                    </div>
                  </div>
                </div>
                <Modal size={"lg"} fullscreen={"md-down"} show={showReturnsModal} onHide={() => setShowReturnsModal(false)}>
                  <ViewReturnsTemplate currentOrder={order} />
                </Modal>
              </div>
            ) : (
              <div>
                <strong>No order found.</strong>
              </div>
            ))}
        </div>
      </PageTemplate>
    </>
  );
};

export default OrderLookup;
